import { NgModule } from '@angular/core';
import { IsAuthenticatedDirective } from './directives/is-authenticated.directive';
import { AsyncPipe, CommonModule, UpperCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckEmptyPipePipe } from '@shared/pipes/empty-pipe';
import { LocalDatePipe } from '@shared/pipes/local-date-pipe';
import { RelativeTimePipe } from '@shared/pipes/relative-time-pipe';
import { NgbAlert, NgbNav, NgbNavContent, NgbNavItem, NgbNavLink, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { LockAlert } from '@shared/components/lock-alert';
import { GoToDirective } from '@shared/directives/go-to.directive';
import { BarcodeDirective } from '@shared/directives/barcode.directive';
import { GlobalSelect } from '@shared/components/global-select';
import { NgLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { UiCard } from '@shared/components/ui-card';
import { FormErrorAlert } from '@shared/components/form-error-alert';
import { FormControlFile } from '@shared/components/form-control-file';
import { LocalCurrencyPipe } from '@shared/pipes/local-currency-pipe';
import { AddressInfo } from '@shared/components/address-info';
import { CustomerLink } from '@shared/components/customer-link';
import { HasRoleDirective } from '@shared/directives/hasRole.directive';
import { DecimalInputDirective } from '@shared/directives/decimal-input.directive';

const items = [
    FormControlFile,
    FormErrorAlert,
    GlobalSelect,
    LockAlert,
    UiCard,
    AddressInfo,
    CustomerLink,

    // Directives
    BarcodeDirective,
    DecimalInputDirective,
    GoToDirective,
    IsAuthenticatedDirective,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    NgOptgroupTemplateDirective,
    HasRoleDirective,

    // Pipes
    AsyncPipe,
    UpperCasePipe,
    TranslatePipe,
    CheckEmptyPipePipe,
    LocalDatePipe,
    LocalCurrencyPipe,
    RelativeTimePipe,

    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Others
    RouterLink,
    NgbAlert,
    NgIcon,
    NgbNav,
    NgbNavItem,
    NgbNavContent,
    NgbNavLink,
    NgbNavOutlet,
    NgSelectComponent,
]

@NgModule({
    imports: items,
    exports: items,
})
export class SharedModule {
}
